import * as d3 from 'd3'
export default {
  methods: {

    draw_dataGroups() {

      let viewbox = this.scroll.viewbox
      let content = this.scroll.content

      let lineHeight = this.values.lineHeight
      let subtotal = this.groups.subTotal
      let groups = this.groups

      this.canvasTable = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto').attr('cursor', 'default')

      this.canvasTable
      .append('line') // Horizontal Line
      .attr('x1', this.header.x).attr('x2', this.header.x + this.header.width).attr('y1', this.header.y + this.header.height).attr('y2', this.header.y + this.header.height)
      .attr('stroke', groups.columns[0].stroke).attr('stroke-width', .5)
      .attr('opacity', 1)

      // CLIP PATH -----------------------------------------------------------------------------
      this.canvasTable
      .append('defs')
      .append('clipPath')
      .attr('id', `CLIP_AREA_${this.localId}`)
      .append('rect')
      .attr('x', this.header.x).attr('y', this.header.y + this.header.height)
      .attr('width', this.header.width).attr('height', viewbox.height)

      let clippedGroup = this.canvasTable
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .attr('clip-path', `url(#CLIP_AREA_${this.localId})`)

       // CANVAS_CONTENTS -----------------------------------------------------------------------------
      this.clippedArea = clippedGroup
      .append('g')
      .attr('id', `CANVAS_CONTENTS_${this.localId}`)
      .attr('transform', `translate(${this.header.x}, ${this.header.y + this.header.height})`)

      this.clippedArea // background for Wheeling
      .append('rect')
      .attr('id', `BG_CONTENTS_${this.localId}`)
      .attr('x', 0).attr('y', 0)
      .attr('width', this.header.width).attr('height', content.height)
      .attr('fill', 'red').attr('opacity', 0)


      let groupTable = this.clippedArea
      .append('g')
      .attr('transform', `translate(0,-0)`)

      let groupLen = this.groups.columns.length
      let lastIdx = this.dataSet.length -1
      let y_ = 0

      this.dataSet.forEach((d,i)=> {

        groups.columns.forEach((col,c)=> {

          if(this.tDisplay && d[col.code]=='OVERALL') {
            groupTable // Background Color
            .append('rect')
            .attr('x', col.sx).attr('y', y_)
            .attr('width', col.width).attr('height', (lastIdx==i) ? lineHeight + 1 : lineHeight)
            .attr('fill', subtotal.bgColor).attr('opacity', subtotal.opacity[d.overallCount-1])
          } else {
            if(this.tDisplay && i < lastIdx && (d[col.code] == null || d[col.code] == 'OVERALL' || this.dataSet[i+1][col.code] == null)) {
              let reversed = subtotal.opacity.toReversed()
              groupTable // Background Color
              .append('rect')
              .attr('x', col.sx).attr('y', y_)
              .attr('width', col.width).attr('height', lineHeight)
              .attr('fill', subtotal.bgColor).attr('opacity', reversed[c+1])
            }
            groupTable
            .append('text')
            .attr('x', col.tx).attr('y', y_ + (lineHeight/2) + groups.tSize*0.36)
            .attr('font-size', groups.tSize).attr('fill', col.tColor)
            .attr('text-anchor', col.align)
            .text(d[col.code])
      
            if(this.header.lineFL != 'Y' && c == 0) {
              //
            } else if(this.header.exxon != 'Y') {
              groupTable
              .append('line') // Vertical Line
              .attr('x1', col.sx).attr('y1', y_ )
              .attr('x2', col.sx).attr('y2', (this.tDisplay && lastIdx==i) ? y_ + lineHeight + 1 : y_ + lineHeight)
              .attr('stroke', col.stroke).attr('stroke-width', .5)
            }
            
          }
        })

        if(i>0) {
          groupTable
          .append('line') // Horizontal Line
          .attr('x1', d.mgx).attr('x2', groups.width).attr('y1', y_ ).attr('y2', y_ )
          .attr('stroke', d.hStroke).attr('stroke-width', .5)
          .attr('opacity', ()=> {
            let val = 1
            if(groupLen==1) {
              if(this.tDisplay) val = (i==lastIdx) ? 1 : 0.3
              else val = (i==0) ? 1 : 0.3
            }  
            return val
          })
        }
        

        // Draw Sub-Total
        if(this.tDisplay && d.overall) {
          groupTable
          .append('text')
          .attr('x', d.ttx).attr('y', (lastIdx==i) ? y_ + (lineHeight/2) + groups.tSize*0.4 : y_ + (lineHeight/2) + groups.tSize*0.36)
          .attr('font-size', (lastIdx==i) ? groups.tSize + .5 : groups.tSize)
          .attr('fill', subtotal.tColor).attr('text-anchor', 'middle')
          .text((lastIdx==i) ? (groups.overallCount == 1) ? 'TOTAL' : 'GRAND TOTAL' : 'SUB TOTAL')
        }

        y_ = y_ + lineHeight
        if(this.tDisplay && lastIdx==i) y_ = y_ + 2
      })

      // Last Horizontal & Vertical Line --------------------------------------
      if(this.header.lineFL != 'Y') {
        //
      } else if(this.tDisplay){
        groupTable
        .append('line') // Vertical Line of First Group
        .attr('x1', 0).attr('x2', 0).attr('y1', y_ -lineHeight - 2).attr('y2', y_)
        .attr('stroke', groups.columns[0].stroke).attr('stroke-width', .5)
      }
      
      groupTable
      .append('line') // Horizontal Line
      .attr('x1', 0).attr('x2', groups.width).attr('y1', y_ ).attr('y2', y_ )
      .attr('stroke', groups.columns[0].stroke).attr('stroke-width', .5)


      this.scroll.content.height = y_
      this.set_ScrollValues()
      d3.select(`#BG_CONTENTS_${this.localId}`).attr('height', y_)
      // console.log(y_)
    },

    
  }
}